export const SERVICE_ID = "service_xzvh8hh";
export const TEMPLATE_ID = "template_vssvxb7";
export const PUBLIC_KEY = "vXu4dv2jc7bJBvCOt";
